import {ACTION_TYPE} from "../../utils/constants";

const initialState = null;

const playOption = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPE.CHANGE_PLAY_OPTION:
      return action.payload;
    default:
      return state;
  }
};

export default playOption;
